import { Icon, ICONS, useMediaDevice } from '@bob/library'
import * as SC from '@websrc/App/Components/Lesson/Navigation/LessonMainNavigation.style'
import { formatString } from '@websrc/App/Helpers/formatting'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { RefObject } from 'react'

export interface LessonMainNavigationProps {
  unitPlanTitle: string
  unitPlanUrl: string
  prevLessonUrl?: string
  lessonNumber: number
  lessonCount: number
  nextLessonUrl?: string
  wrapperRef?: RefObject<HTMLDivElement>
}

export const LessonMainNavigation = ({
  lessonCount,
  lessonNumber,
  nextLessonUrl,
  prevLessonUrl,
  unitPlanTitle,
  unitPlanUrl,
  wrapperRef,
}: LessonMainNavigationProps) => {
  const t = useStaticText()
  const device = useMediaDevice()

  const unitPlan = `${t.plans_lessons_worksheets.unit_plan}${
    device === 'desktop' ? `: ${unitPlanTitle}` : ''
  }`

  return (
    <SC.LessonMainNavigation data-testid={'unit_bar'} ref={wrapperRef}>
      <SC.LinkButton aria-label={unitPlan} data-testid={'unit_title'} to={unitPlanUrl}>
        <Icon icon={ICONS.ARROW_LEFT} size={20} />
        <Icon icon={ICONS.ARROW_LEFT} size={20} />
        {unitPlan}
      </SC.LinkButton>
      <SC.ButtonWrapper>
        {prevLessonUrl && (
          <SC.LinkButton
            aria-label={t.plans_lessons_worksheets.previous_lesson}
            data-testid={'previous_lesson'}
            to={prevLessonUrl}
          >
            <Icon icon={ICONS.ARROW_LEFT} size={20} />
          </SC.LinkButton>
        )}
        <SC.SideText>
          {formatString(t.plans_lessons_worksheets.lesson_number_of, lessonNumber, lessonCount)}
        </SC.SideText>
        {nextLessonUrl ? (
          <SC.LinkButton
            aria-label={t.plans_lessons_worksheets.next_lesson}
            data-testid={'next_lesson'}
            to={nextLessonUrl}
          >
            <Icon icon={ICONS.ARROW_RIGHT} size={20} />
          </SC.LinkButton>
        ) : (
          <SC.EmptySpace size={40} />
        )}
      </SC.ButtonWrapper>
    </SC.LessonMainNavigation>
  )
}
